/**
 * Utilidades para formateo de fechas y horas
 */

/**
 * Formatea una fecha string a formato legible (solo fecha)
 * @param {string} dateString - Fecha en formato ISO (ej: "2025-09-01T18:42:16.947")
 * @returns {string} - Fecha formateada (ej: "01/09/2025")
 */
export const formatDateOnly = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};

/**
 * Formatea una fecha string a formato legible (solo hora)
 * @param {string} dateString - Fecha en formato ISO (ej: "2025-09-01T18:42:16.947")
 * @returns {string} - Hora formateada (ej: "18:42:16")
 */
export const formatTimeOnly = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  return date.toLocaleTimeString('es-ES', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
};

/**
 * Formatea una fecha string a formato completo (fecha y hora)
 * @param {string} dateString - Fecha en formato ISO
 * @returns {string} - Fecha y hora formateadas (ej: "01/09/2025, 18:42:16")
 */
export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  return date.toLocaleString('es-ES', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
};

/**
 * Formatea una fecha string a formato personalizado
 * @param {string} dateString - Fecha en formato ISO
 * @param {Object} options - Opciones de formato para toLocaleDateString
 * @returns {string} - Fecha formateada según las opciones
 */
export const formatCustomDate = (dateString, options = {}) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const defaultOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    ...options
  };
  
  return date.toLocaleDateString('es-ES', defaultOptions);
};

export const generateGUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

// Exportación por defecto con todas las funciones
const Tools = {
  formatDateOnly,
  formatTimeOnly,
  formatDateTime,
  formatCustomDate,
  generateGUID
};

export default Tools;